<app-logo-area [breadcrumbs]="breadCrumbs()"></app-logo-area>

<main>
  <app-headline-section [title]="poItemId() + ' Details'"></app-headline-section>

  @if (loading) {
    <section class="cl-section cl-section-regular">
      <div style="height: 10vh"></div>
      <div style="width: 100%; display: flex; align-items: center; justify-content: center;">
        <div class="cl-spinner">Loading Encode Details ...<i class="fas fa-spinner fa-spin"></i></div>
      </div>
    </section>
  }
  @if (loadError()) {
    <section class="cl-section cl-section-regular">
      <div class="container"><p class="alert cl-alert-danger" role="alert">Could not load the encode details: {{ loadError() }}</p></div>
    </section>
  }

  @if (poItem(); as poItem) {

    <!-- Action Bar -->
    <section class="cl-section cl-section-regular">
      <div class="container">
        <p class="alert cl-alert-action">
          @if (PO_DESTINATIONS[poItem['po_destination']] != null && PO_DESTINATIONS[poItem['po_destination']].publishable) {
            <a role="button"
               [class.cl-a-disabled]="publish_single_po_inflight"
               [class.cl-a-spinner]="publish_single_po_inflight"
               (click)="publish_single_po()">
              Publish
            </a>
          }
          @if (PO_DESTINATIONS[poItem['po_destination']] != null && PO_DESTINATIONS[poItem['po_destination']].publishable && (poItem.publish_process?.state == 'SUCCESS' || publishReports().length > 0)) {
            <a role="button" target="_blank" rel="noopener noreferrer"
               [routerLink]="['/reports', organization()?.id, poItem.po.po_name, poItem.po_item_id]">
              <span class="cl-a-external">Delivery Report</span>
            </a>
          }
          @if ('contentplatform:workflow:Mutation/RestartPoItem' | isAllowed:'contentplatform:po:input.po_name/' + poItem.po.po_name: organization()) {
            <a role="button"
               [class.cl-a-disabled]="restart_single_po_inflight"
               [class.cl-a-spinner]="restart_single_po_inflight"
               (click)="restartWorkflow()">
              Restart
            </a>
          }
        </p>
      </div>
    </section>

    <!-- Publication -->
    @if (poItem.publish_process || publishReports().length > 0) {
      <section class="cl-section cl-section-regular">
        <div class="container cl-spacing-small">
          <div class="card">
            <div class="card-header">
              Publication
              <div class="cl-card-info">
                @if (poItem.publish_process) {
                  @if (poItem.publish_process.state == 'ABORTED') {
                    <span class="cl-badge cl-badge-fixed cl-color-clay">Aborted</span>
                  }
                  @if (poItem.publish_process.state == 'IN_PROGRESS') {
                    <span class="cl-badge cl-badge-fixed cl-color-sky">{{ poItem.publish_process | publishStatus }}</span>
                  }
                  @if (poItem.publish_process.state == 'FAILED') {
                    <span class="cl-badge cl-badge-fixed cl-color-berry">Failed</span>
                  }
                  @if (poItem.publish_process.state == 'SUCCESS') {
                    @switch (poItem.po_destination) {
                      @case ("safran-album") {
                        <span class="cl-badge cl-badge-fixed cl-color-petrol">Selected</span>
                      }
                      @default {
                        <span class="cl-badge cl-badge-fixed cl-color-petrol">Published</span>
                      }
                    }
                  }
                }
              </div>
            </div>
            <div class="card-body">
              @if (poItem.publish_process) {
                @if (poItem.publish_process.state == 'FAILED') {
                  <p class="alert cl-alert-error">{{ poItem.publish_process.message }}</p>
                }
                <p>
                  @if (poItem.publish_process.state !== 'IN_PROGRESS') {
                    {{ poItem.publish_process.start_date | duration: poItem.publish_process.end_date }}
                    (<app-date [value]="poItem.publish_process.start_date" />
                    &ndash; <app-date [value]="poItem.publish_process.end_date" />)
                  }
                  @if (poItem.publish_process.state === 'IN_PROGRESS') {
                    Started: <app-date [value]="poItem.publish_process.start_date" />
                  }
                  &middot;
                  <app-process-link [processId]="poItem.publish_process.id" [type]="'wf'"></app-process-link>
                </p>
                <p>
                  Destination: {{ poItem.po_destination }}
                  <!-- Only for the 'vod' destination. These URLs address the castlabs-vod origin
                       behind vod{env}.cp.castlabs.com, and only that destination syncs there --
                       every other one writes to its own target, so the link 404s while the item is
                       genuinely published. The workflow being vod_default is not enough: an item can
                       run it and still be published somewhere else entirely. -->
                  @if (poItem.workflow === 'start_workflow_vod_default' && poItem.po_destination === 'vod' && poItem.publish_process.state === 'SUCCESS') {
                    &middot;
                    <a class="cl-a-external"
                       href="https://vod{{envsuffix}}.cp.castlabs.com/{{poItem.customer}}/{{poItem.po.po_name}}/{{poItem.po_item_id}}/dash.mpd">DASH</a>
                    /
                    <a class="cl-a-external"
                       href="https://vod{{envsuffix}}.cp.castlabs.com/{{poItem.customer}}/{{poItem.po.po_name}}/{{poItem.po_item_id}}/hls.m3u8">HLS</a>
                  }
                  @if (PO_DESTINATIONS[poItem['po_destination']] != null && PO_DESTINATIONS[poItem['po_destination']].publishable && poItem.publish_process.state === 'SUCCESS') {
                    &middot;
                    <a class="cl-a" target="_blank" rel="noopener noreferrer"
                       [routerLink]="['/reports', organization()?.id, poItem.po.po_name, poItem.po_item_id]">
                      Delivery Report
                    </a>
                  }
                </p>
              }

              @if (publishReports().length > 0) {
                <div class="cl-table-scroll">
                  <table class="cl-table-data">
                    <thead>
                      <tr>
                        <th class="cl-table-head">Filename</th>
                        <th class="cl-table-head cl-th-currency">Size</th>
                        <th class="cl-table-head">Delivered</th>
                        <th class="cl-table-head">Method</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (report of publishReports(); track $index) {
                        @if ($index === previousDeliveryIndex()) {
                          <tr>
                            <td colspan="100" class="cl-faded">All files below have been delivered by previous workflows</td>
                          </tr>
                        }
                        <tr>
                          <td>
                            @if (publishedFileUrl(report.filename, $index); as fileUrl) {
                              <a class="cl-a-external" [href]="fileUrl" target="_blank"
                                 rel="noopener noreferrer">{{ report.filename }}</a>
                            } @else {
                              {{ report.filename }}
                            }
                          </td>
                          <td class="cl-td-currency">{{ report.size | fileSize }}</td>
                          <td class="cl-td-time"><app-date [value]="report.completed_at" /></td>
                          <td>{{ report.delivery_method }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>
          </div>
        </div>
      </section>
    }

    <!-- Discovery & Encode -->
    <section class="cl-section cl-section-regular">
      <div class="container cl-spacing-small">
        <div class="card">
          <div class="card-header">
            Discovery &amp; Encode
            <div class="cl-card-info">
              @if (poItem.workflow_process.state == 'IN_PROGRESS') {
                @if (!poItem.checkpoint_content_complete && poItem.input_brefix.length > 1) {
                  <span class="cl-badge cl-badge-fixed cl-color-sky">Waiting for files</span>
                }
                @if (!poItem.checkpoint_content_complete && poItem.input_brefix == '/') {
                  <span class="cl-badge cl-badge-fixed cl-color-sky">Resolving Identifier</span>
                }
                @if (poItem.checkpoint_content_complete && !poItem.checkpoint_encodes_done) {
                  <span class="cl-badge cl-badge-fixed cl-color-sky">Encoding ...</span>
                }
                @if (poItem.checkpoint_content_complete && poItem.checkpoint_encodes_done) {
                  <span class="cl-badge cl-badge-fixed cl-color-sky">Encodes Done</span>
                }
              }
              @if (poItem.workflow_process.state == 'FAILED') {
                <span class="cl-badge cl-badge-fixed cl-color-berry">Failed</span>
              }
              @if (poItem.workflow_process.state == 'SUCCESS') {
                <span class="cl-badge cl-badge-fixed cl-color-petrol">Encoded</span>
              }
              @if (poItem.workflow_process.state == 'ABORTED') {
                <span class="cl-badge cl-badge-fixed cl-color-clay">Aborted</span>
              }
            </div>
          </div>
          <div class="card-body">
            @if (poItem.workflow_process.state == 'FAILED') {
              <p class="alert cl-alert-error">{{ poItem.workflow_process.message }}</p>
              @if (poItem.workflow_process.data | processFailureDetail: poItem.workflow_process.message; as failure) {
                @if (failure.detail || failure.errorType) {
                  <p class="cl-p-small">
                    @if (failure.errorType) {
                      <span class="cl-badge cl-badge-sm cl-color-berry">{{ failure.errorType }}</span>
                    }
                    @if (failure.detail) {
                      {{ failure.detail }}
                    }
                  </p>
                }
              }
            }
            <p>
              @if (poItem.workflow_process.state !== 'IN_PROGRESS') {
                {{ poItem.workflow_process.start_date | duration: poItem.workflow_process.end_date }}
                (<app-date [value]="poItem.workflow_process.start_date" />
                &ndash; <app-date [value]="poItem.workflow_process.end_date" />)
              }
              @if (poItem.workflow_process.state === 'IN_PROGRESS') {
                Started: <app-date [value]="poItem.workflow_process.start_date" />
              }
              &middot;
              <app-process-link [processId]="poItem.workflow_process.id" [type]="'wf'"></app-process-link>
              @if (staff()) {
                &middot;
                <a rel="noopener noreferrer" class="cl-a-external"
                   [href]="'https://us-east-1.console.aws.amazon.com/dynamodbv2/home?region=us-east-1#edit-item?itemMode=2&pk=' + poItem.po.po_name + '&route=ROUTE_ITEM_EXPLORER&sk=' + poItem.po_item_id + '&table=' + tablename">Workflow DB Item</a>
              }
            </p>

            <!-- Produced Files -->
            @if (filesError()) {
              <p class="alert cl-alert-danger" role="alert">Could not list the produced files: {{ filesError() }}</p>
            }
            @if (encodeFiles().length > 0) {
              <h4>Produced Files
                <app-s3-link [fof]="'s3://' + poItem.output_brefix"></app-s3-link>
                @if (poItem.preview && (poItem.preview.dash_manifest_url || poItem.preview.hls_manifest_url)) {
                  &middot;
                  <a class="cl-a"
                     [routerLink]="['/o', organization().id, 'workflows', poItem.po.po_name.split('_')[0], poItem.po.po_name, poItem.po_item_id, 'preview']"
                     role="link">Preview</a>
                }
              </h4>
              <div class="cl-table-scroll">
                <table class="cl-table-data">
                  <thead>
                    <tr>
                      <th class="cl-table-head">Filename</th>
                      <th class="cl-table-head cl-th-currency">Size</th>
                      <th class="cl-table-head">Last Modified</th>
                      <th class="cl-table-head cl-th-links"></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (file of encodeFiles(); track file.id) {
                      <tr [class.cl-faded]="renameInflight() === file.id || deleteInflight() === file.id">
                        <td class="cl-form">
                          @if (editingId === file.id) {
                            <input type="text" class="form-control form-control-sm"
                                   [(ngModel)]="editingName"
                                   [disabled]="renameInflight() === file.id"
                                   (keyup.enter)="saveRename(file)"
                                   (keyup.escape)="cancelRename()" />
                          } @else if (renameInflight() === file.id || deleteInflight() === file.id) {
                            <span><i class="fas fa-spinner fa-spin"></i> {{ file.name }}</span>
                          } @else {
                            <span [class.cl-animation-flash-text]="copiedFileId() === file.id">{{ file.name }}</span>
                          }
                        </td>
                        <td class="cl-td-currency">{{ file.size | fileSize }}</td>
                        <td class="cl-td-time"><app-date [value]="file.last_modified" /></td>
                        <td class="cl-td-links" width="1%">
                          @if (editingId === file.id) {
                            <a class="cl-a-btn cl-a-primary" role="button"
                               [class.cl-a-disabled]="renameInflight() === file.id"
                               [class.cl-a-spinner]="renameInflight() === file.id"
                               (click)="saveRename(file)">Save</a>
                            <a class="cl-a-btn" role="button"
                               [class.cl-a-disabled]="renameInflight() === file.id"
                               (click)="cancelRename()">Cancel</a>
                          } @else if (deleteConfirmId === file.id) {
                            <span class="cl-text-danger">Delete?</span>
                            <a class="cl-a-btn cl-a-danger" role="button" (click)="deleteFile(file)">Confirm</a>
                            <a class="cl-a-btn" role="button" (click)="cancelDelete()">Cancel</a>
                          } @else {
                            @if (canDownload(file)) {
                              <a class="cl-a-btn cl-a-primary" role="button" (click)="downloadFile(file)">Download</a>
                            }
                            @if (canRename(file)) {
                              <a class="cl-a-btn" role="button" (click)="startRename(file)">Rename</a>
                            }
                            <a class="cl-a-btn cl-a-primary" role="button" (click)="copyS3Path(file)">
                              Copy S3 path
                            </a>
                            <a class="cl-a-btn" role="button" (click)="confirmDelete(file)">Delete</a>
                            @if (canShowTsaLog(file)) {
                              <a class="cl-a-btn" role="button" (click)="openTsaLog(file)">TS Log</a>
                            }
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }

            <!-- Encoding Jobs -->
            @if (poItem.vtk_jobs.length > 0) {
              <h4>Encoding Jobs</h4>
              <div class="cl-table-scroll">
                <table class="cl-table-data">
                  <thead>
                    <tr>
                      <th class="cl-table-head">ID</th>
                      <th class="cl-table-head">Status</th>
                      <th class="cl-table-head">Created</th>
                      <th class="cl-table-head">Modified</th>
                      <th class="cl-table-head cl-th-links"></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (vtk_job of poItem.vtk_jobs; track vtk_job.id) {
                      <tr>
                        <td class="cl-cursor-pointer cl-td-id" [appTooltip]="`${vtk_job.id}\nclick-to-copy!`" tooltipPlacement="end" tooltipColor="light" (click)="copyVtkJobId(vtk_job.id)">
                          @if (vtk_job.id) {
                            <span [class.cl-animation-flash-text]="copiedVtkJobId() === vtk_job.id">{{ vtk_job.id }}</span>
                          }
                        </td>
                        <td class="cl-cursor-pointer" (click)="goToVtkJob(poItem, vtk_job)">{{ vtk_job.status_text }}</td>
                        <td class="cl-cursor-pointer cl-td-time" (click)="goToVtkJob(poItem, vtk_job)"><app-date [value]="vtk_job.created" /></td>
                        <td class="cl-cursor-pointer cl-td-time" (click)="goToVtkJob(poItem, vtk_job)"><app-date [value]="vtk_job.modified" /></td>
                        <td class="cl-td-links" width="1%">
                          <a class="cl-a-btn cl-a-primary" [routerLink]="['/o', organization()?.id, 'workflows', poItem.po!.airline, poItem.po!.po_name, poItem.po_item_id, 'vtk-jobs', vtk_job.id]"
                               appTooltip="View job details within the portal" tooltipPlacement="top" tooltipColor="light">View</a>
                          <a class="cl-a-btn cl-a-primary cl-a-external cl-p-small" target="_blank" rel="noopener noreferrer"
                             href="{{ VTK_SERVER }}/#/o/{{ vtk_job.organization_urn }}/jobs/{{ vtk_job.id }}?as={{ organization()?.id }}">Open in VTK</a>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }

            <!-- Input Files -->
            @if (poItem.checkpoint_content_uploaded || poItem.tracks.length > 0) {
              <h4>Input Files
                <app-s3-link [fof]="'s3://' + poItem.input_brefix"></app-s3-link>
                &middot;
                <a class="cl-a" [routerLink]="'/o/' + organization().id + '/files/browse/' + poItem.input_brefix">Go to source folder</a>
              </h4>
              <div class="cl-table-scroll">
                <table class="cl-table-data">
                  <thead>
                    <tr>
                      <th class="cl-table-head">Requested</th>
                      <th class="cl-table-head">Selected</th>
                      <th class="cl-table-head">Messages</th>
                    </tr>
                  </thead>
                  <tbody>
                    @if (poItem.tracks.length === 0) {
                      <tr class="cl-tr-no-data">
                        <td colspan="100">No files available in source directory.</td>
                      </tr>
                    }
                    @for (element of poItem.tracks; track $index) {
                      <tr>
                        <td style="white-space: nowrap">{{ element.codec_type }} <app-language [code]="element.lang" [trackType]="element.codec_type"/></td>
                        <td>
                          @if (element.source) {
                            <dt>
                              <a class="cl-a" [routerLink]="'/o/' + organization().id + '/files/details/' + poItem.input_brefix + element.source.key">{{ element.source.key }}</a>
                            </dt>
                            @if (element.source.coded_width) {
                              <dd>Resolution: {{ element.source.coded_width }}x{{ element.source.coded_height }}</dd>
                            }
                            @if (element.source.language) {
                              <dd>Language (BCP-47): <app-language [code]="element.source.language" [trackType]="element.codec_type"/></dd>
                            }
                            @if (element.source.codec_type) {
                              <dd>Type: {{ element.source.codec_type }}</dd>
                            }
                          }
                        </td>
                        <td>
                          <ul>
                            @for (msg of element.messages; track msg) {
                              <li style="white-space: break-spaces;">
                                @if (msg.toLowerCase().includes('restor')) {
                                  <span class="alert cl-alert-info">{{ msg }}</span>
                                } @else {
                                  {{ msg }}
                                }
                              </li>
                            }
                          </ul>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        </div>
      </div>
    </section>

    <!-- Workflow Parameters -->
    <section class="cl-section cl-section-regular">
      <div class="container cl-spacing-small">
        <div class="card">
          <div class="card-header">
            Workflow Parameters
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <dl>
                  <dt>Workflow type / Template / Filename</dt>
                  <dd>{{ poItem.workflow.substring(15) }} / {{ poItem.vtk_template }} / {{ poItem.filename }}</dd>

                  @if (hasVideoTrack()) {
                    <dt>Aspect Ratio</dt>
                    <dd>{{ aspectRatioLabel(poItem.aspect_ratio) }}</dd>
                  }

                  @if (poItem.po_destination) {
                    <dt>PO Destination</dt>
                    <dd>{{ poItem.po_destination }}</dd>
                  }

                  @if (poItem.metadata_source) {
                    <dt>Metadata Source</dt>
                    <dd>{{ poItem.metadata_source }}</dd>
                  }

                  @if (poItem.wrap_up_workflow) {
                    <dt>Wrap Up Workflow</dt>
                    <dd>{{ poItem.wrap_up_workflow }}</dd>
                  }
                </dl>
              </div>

              <div class="col-md-6">
                <dl>
                  @if (poItem.email_notification?.length) {
                    <dt>Email Notification</dt>
                    <dd>{{ poItem.email_notification.join(', ') }}</dd>
                  }

                  @if (poItem.email_notification_publish?.length) {
                    <dt>Publish Notification Email</dt>
                    <dd>{{ poItem.email_notification_publish.join(', ') }}</dd>
                  }
                </dl>
              </div>
            </div>
            @if (poItem.content_identifier) {
              <h4>Content Identifier</h4>
              <div class="pre-container">
                <pre>{{ poItem.content_identifier }}</pre>
                <app-do-button class="pre-copy-btn"
                  [messageField]="content_identifier_message"
                  (actionTriggered)="copyToClipboard($event, poItem.content_identifier)" buttonClass="btn cl-btn-icon cl-color-tertiary it-cancel">
                  <i class="fas fa-copy"></i>
                </app-do-button>
              </div>
              <app-message-field #content_identifier_message/>
            }
            @if (poItem.format_specific_data_json) {
              <h4>Format Specific Data</h4>
              <div class="pre-container">
                <pre>{{ poItem.format_specific_data_json | json }}</pre>
                <app-do-button class="pre-copy-btn"
                  [messageField]="format_specific_data_message"
                  (actionTriggered)="copyToClipboard($event, poItem.format_specific_data_json)" buttonClass="btn cl-btn-icon cl-color-tertiary it-cancel">
                  <i class="fas fa-copy"></i>
                </app-do-button>
              </div>
              <app-message-field #format_specific_data_message/>
            }
          </div>
        </div>
      </div>
    </section>

  }
</main>
